import { render, staticRenderFns } from "./TravelLog.vue?vue&type=template&id=379e5508"
import script from "./TravelLog.vue?vue&type=script&lang=js"
export * from "./TravelLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports